import React from 'react';
import PropTypes from 'prop-types';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection } from 'lexical';

const NodeReferencePlugin = ({ onNodeRef }) => {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    const unregisterListener = editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        // Get the selection
        const selection = $getSelection();

        if (!selection) return;

        if (selection.anchor) {
          // Get the anchor node (where cursor is)
          const node = selection.anchor.getNode();

          // Get DOM element reference
          const element = editor.getElementByKey(node.getKey());

          // Pass the element reference to callback
          if (element) {
            onNodeRef(element);
          }
        }
      });
    });

    return unregisterListener;
  }, [editor, onNodeRef]);

  return null;
};

NodeReferencePlugin.propTypes = {
  onNodeRef: PropTypes.func.isRequired
};

export { NodeReferencePlugin };
